import { Form } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { COMMON_ERROR } from '../../../../shared/constants/commonConstants';
import useMigrateRiClaimData from '../../../../shared/hooks/useMigrateRIclaimData';
import { Payer } from '../../../../shared/models/payer.model';
import { RootState } from '../../../../store';
import { fetchClaimDetails } from '../../../../store/actions/claimDetailsAction';
import { fetchLookUpValues } from '../../../../store/actions/lookUpAction';
import { changePayer } from '../../../../store/actions/payerListAction';
import { resetReimbursement, updateRIClaimData } from '../../../../store/actions/reimbursementAction';
import { PayerLookUpState } from '../../../../store/models/lookUpModel';
import { PayerInitialState } from '../../../../store/models/payerListModel';
import { base64UrlDecode, centeredNotification } from '../../../../utils/utility';
import { claimDetailMigrateToClaimForm } from '../../../crm/inPatient/service/crmUtils';
import DetailContent from '../detail/DetailContent';
import HeaderRightAction from '../newAdmission/HeaderRightAction/HeaderRightAction';

const EditReimbursement = ({ match, location: { pathname } }: any): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [detailLoading, setDetailLoading] = useState(false);
  const [editForm] = Form.useForm();
  const { migrateRIClaimDetail } = useMigrateRiClaimData();

  const { reimbursementPayers: payerList, payer } = useSelector((state: RootState): PayerInitialState => state?.payerList || {});
  const payerLookup = useSelector((state: RootState): PayerLookUpState => state?.payerLookUp);

  useEffect((): any => {
    try {
      const { params: { data } } = match;
      const selectedClaimData = JSON.parse(base64UrlDecode(data));
      const { hospActionId, payerClaimNo, payerId, productCode } = selectedClaimData || {};

      // if (!action) {
      //   const dataToOpenDetail = { hospActionId, payerClaimNo, payerId, productCode };
      //   history.push(`/reimbursement/home/detail/${base64UrlEncode(JSON.stringify(dataToOpenDetail))}`);
      // }

      // * Change payer
      const uniquePayerId = `${payerId}${productCode || ''}`;
      const selectedPayer = payerList?.find((ele: Payer): boolean => ele?.uniqueIdentifier === uniquePayerId);
      if (selectedPayer) {
        dispatch(changePayer(selectedPayer));
        setDetailLoading(true);
        dispatch(fetchLookUpValues(
          (): any => fetchClaimDetail(selectedPayer, hospActionId, payerClaimNo),
          uniquePayerId,
        ));
      } else {
        centeredNotification(COMMON_ERROR);
        history.push('/reimbursement');
      }
    } catch (e) {
      centeredNotification(COMMON_ERROR);
      history.push('/reimbursement');
    }
    return (): any => dispatch(resetReimbursement());
  }, []);

  const fetchClaimDetail = (selectedPayer: Payer, hospActionId: any, claimNo: any): any => {
    setDetailLoading(true);
    dispatch(fetchClaimDetails({
      claimNo,
      actionId: parseInt(hospActionId, 10),
      payerId: selectedPayer?.id,
      isReimbursementClaim: true,
      successCallback,
      failedCallback,
    }));
  };

  const successCallback = (claimDetail: any): any => {
    const { district = [], relation = [], designation = [] } = payerLookup[payer?.uniqueIdentifier] || {};
    const updatedClaim = claimDetailMigrateToClaimForm(claimDetail, pathname, payerList, {
      district,
      relation,
      designation,
    });
    dispatch(updateRIClaimData(updatedClaim));
    const migratedClaimDetail = migrateRIClaimDetail(updatedClaim);
    editForm.setFieldsValue(migratedClaimDetail || {});
    setDetailLoading(false);
  };
  const failedCallback = (err?: any): any => {
    centeredNotification(err || COMMON_ERROR);
    history.goBack();
    setDetailLoading(false);
  };

  return (
    <div>
      <PageHeader
        backUrl="/reimbursement/home/list"
        pageTitle="Reimbursement details"
        rightComponent={HeaderRightAction}
      />
      <DetailContent
        detailForm={editForm}
        isLoading={detailLoading}
      />
    </div>
  );
};

export default EditReimbursement;
